import { render, staticRenderFns } from "./CompanyDataUpdateTab.vue?vue&type=template&id=f08a0996&scoped=true&"
import script from "./CompanyDataUpdateTab.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateTab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateTab.vue?vue&type=style&index=0&id=f08a0996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08a0996",
  null
  
)

export default component.exports